var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChartLine = function SvgIconChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 4.5a1 1 0 1 0-2 0v15a1 1 0 0 0 1 1h18a1 1 0 1 0 0-2H4v-3.046l5.048-4.418L14.4 15.05a1 1 0 0 0 1.258-.047l6-5.25a1 1 0 1 0-1.317-1.506l-5.39 4.717L9.6 8.95a1 1 0 0 0-1.258.047L4 12.797z"
  })));
};
export default SvgIconChartLine;